import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useGetFiltersInfo from '../hooks/useGetFiltersInfo';
import OptionsSelector from '../ui/OptionsSelector';

const SellerFilter = ({ type }) => {
  const { data, prevData, params, updateParams } = useGetFiltersInfo();
  const { t } = useTranslation('search');

  const options = data?.sellers || prevData?.sellers || [];

  const onChange = (value) => {
    updateParams({
      sellers: value,
      page: 1,
    });
  };

  return (
    <OptionsSelector
      id="seller-filter"
      onChange={onChange}
      options={options}
      placeholder={t('Search')}
      type={type}
      value={params.sellers}
    />
  );
};

SellerFilter.propTypes = {
  type: PropTypes.string.isRequired,
};

export default SellerFilter;
